class NewsletterForm {
    constructor(form) {
        this.form = form;
        this.messageContainer = form.querySelector('[data-newsletter-message]');
        this.submitButton = form.querySelector('.newsletter-submit-btn');
        this.originalButtonText = this.submitButton.textContent;

        this.init();
    }

    init() {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
    }

    // Função para obter valores dos campos do formulário
    getNewsletterVal(selector) {
        const element = this.form.querySelector(selector);
        if (!element) return '';

        if (element.type === 'radio') {
            return element.checked ? element.value : '';
        }

        return element.value.trim();
    }

    // Coleta todos os dados do formulário
    collectFormData() {
        // Coleta dados dos radio buttons corretamente
        const radioButtons = this.form.querySelectorAll('input[name="shoe_interest"]:checked');
        let selectedInterest = '';
        if (radioButtons.length > 0) {
            selectedInterest = radioButtons[0].value;
        }

        return {
            responsibleName: this.getNewsletterVal('#responsible-name'),
            childName: this.getNewsletterVal('#child_name'),
            email: this.getNewsletterVal('#email-responsible'),
            interest: selectedInterest
        };
    }

    // Encontra o formulário do app na página (incluindo shadowRoot)
    findAppForm() {
        console.log('Procurando formulário do app...');

        // 1. Procura no shadowRoot do #app-embed (como no código de referência)
        const appEmbed = document.getElementById('app-embed');
        if (appEmbed && appEmbed.shadowRoot) {
            console.log('Encontrado #app-embed com shadowRoot');
            const shadowForm = appEmbed.shadowRoot.querySelector('form');
            if (shadowForm) {
                console.log('Formulário encontrado no shadowRoot:', shadowForm);
                return shadowForm;
            }
        }

        // 2. Procura pelo formulário do app usando os seletores específicos
        const appForm = document.querySelector('form[data-testid="form"]');
        if (appForm) {
            console.log('Formulário encontrado com data-testid="form":', appForm);
            return appForm;
        }

        // 3. Fallback: procura por formulário com os campos específicos do app
        const forms = document.querySelectorAll('form');
        console.log('Procurando em', forms.length, 'formulários...');

        for (let form of forms) {
            const hasFirstName = form.querySelector('#first_name');
            const hasEmail = form.querySelector('#email');
            const hasCustomField = form.querySelector('#custom\\#nome-crianca, [id*="nome-crianca"]');

            if (hasFirstName && hasEmail && hasCustomField) {
                console.log('Formulário encontrado por campos específicos:', form);
                return form;
            }
        }

        console.log('Nenhum formulário do app encontrado');
        return null;
    }

    // Aguarda o formulário do app estar disponível
    async waitForAppForm(maxAttempts = 10) {
        for (let i = 0; i < maxAttempts; i++) {
            console.log(`Tentativa ${i + 1} de encontrar o formulário do app...`);
            const appForm = this.findAppForm();
            if (appForm) {
                console.log('Formulário do app encontrado!');
                return appForm;
            }

            // Aguarda 500ms antes da próxima tentativa
            await new Promise(resolve => setTimeout(resolve, 500));
        }

        console.log('Formulário do app não encontrado após todas as tentativas');
        return null;
    }

    // Preenche os campos do formulário do app
    fillAppForm(data) {
        const appForm = this.findAppForm();
        if (!appForm) {
            console.error('Formulário do app não encontrado');
            return false;
        }

        console.log('=== INICIANDO PREENCHIMENTO DO FORMULÁRIO DO APP ===');
        console.log('Dados recebidos:', data);
        console.log('Formulário do app encontrado:', appForm);

        try {
            // Preenche nome do responsável
            console.log('--- Preenchendo nome do responsável ---');
            const firstNameField = appForm.querySelector('#first_name');
            console.log('Campo first_name encontrado:', firstNameField);

            if (firstNameField && data.responsibleName) {
                console.log('Valor antes:', firstNameField.value);
                firstNameField.value = data.responsibleName;
                console.log('Valor depois:', firstNameField.value);

                // Dispara eventos para ativar validações do app
                firstNameField.dispatchEvent(new Event('input', { bubbles: true }));
                firstNameField.dispatchEvent(new Event('change', { bubbles: true }));
                firstNameField.dispatchEvent(new Event('blur', { bubbles: true }));

                // Força foco e desfoque para ativar labels flutuantes
                firstNameField.focus();
                setTimeout(() => firstNameField.blur(), 100);
            } else {
                console.log('Campo first_name não encontrado ou dados vazios');
            }

            // Preenche email
            console.log('--- Preenchendo email ---');
            const emailField = appForm.querySelector('#email');
            console.log('Campo email encontrado:', emailField);

            if (emailField && data.email) {
                console.log('Valor antes:', emailField.value);
                emailField.value = data.email;
                console.log('Valor depois:', emailField.value);

                emailField.dispatchEvent(new Event('input', { bubbles: true }));
                emailField.dispatchEvent(new Event('change', { bubbles: true }));
                emailField.dispatchEvent(new Event('blur', { bubbles: true }));

                emailField.focus();
                setTimeout(() => emailField.blur(), 100);
            } else {
                console.log('Campo email não encontrado ou dados vazios');
            }

            // Preenche nome da criança
            console.log('--- Preenchendo nome da criança ---');
            const childNameField = appForm.querySelector('#custom\\#nome-crianca');
            console.log('Campo nome-crianca encontrado:', childNameField);

            if (childNameField && data.childName) {
                console.log('Valor antes:', childNameField.value);
                childNameField.value = data.childName;
                console.log('Valor depois:', childNameField.value);

                childNameField.dispatchEvent(new Event('input', { bubbles: true }));
                childNameField.dispatchEvent(new Event('change', { bubbles: true }));
                childNameField.dispatchEvent(new Event('blur', { bubbles: true }));

                childNameField.focus();
                setTimeout(() => childNameField.blur(), 100);
            } else {
                console.log('Campo nome-crianca não encontrado ou dados vazios');
            }

            // Seleciona opção de interesse
            console.log('--- Selecionando interesse ---');
            console.log('Interesse recebido:', data.interest);

            if (data.interest) {
                let targetRadio = null;

                // Mapeia os valores do nosso formulário para os do app
                if (data.interest.toLowerCase().includes('menino') && !data.interest.toLowerCase().includes('menina')) {
                    console.log('Procurando radio para Meninos...');
                    targetRadio = appForm.querySelector('#custom\\#tenho_interesse_em_calados_para-Meninos');
                } else if (data.interest.toLowerCase().includes('menina') && !data.interest.toLowerCase().includes('menino')) {
                    console.log('Procurando radio para Meninas...');
                    targetRadio = appForm.querySelector('#custom\\#tenho_interesse_em_calados_para-Meninas');
                } else if (data.interest.toLowerCase().includes('ambos') ||
                    (data.interest.toLowerCase().includes('menino') && data.interest.toLowerCase().includes('menina'))) {
                    console.log('Procurando radio para Meninos e Meninas...');
                    targetRadio = appForm.querySelector('#custom\\#tenho_interesse_em_calados_para-Meninos\\ e\\ Meninas');
                }

                console.log('Radio button encontrado:', targetRadio);

                if (targetRadio) {
                    console.log('Selecionando radio button...');
                    targetRadio.checked = true;
                    targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
                    targetRadio.dispatchEvent(new Event('click', { bubbles: true }));
                    console.log('Radio button selecionado:', targetRadio.checked);
                } else {
                    console.log('Radio button não encontrado para interesse:', data.interest);
                    // Lista todos os radio buttons disponíveis
                    const allRadios = appForm.querySelectorAll('input[type="radio"]');
                    console.log('Radio buttons disponíveis:', allRadios);
                    allRadios.forEach((radio, index) => {
                        console.log(`Radio ${index}:`, radio.id, radio.value, radio.name);
                    });
                }
            }

            console.log('=== PREENCHIMENTO CONCLUÍDO ===');
            return true;
        } catch (error) {
            console.error('Erro ao preencher formulário do app:', error);
            return false;
        }
    }

    // Submete o formulário do app
    submitAppForm() {
        const appForm = this.findAppForm();
        if (!appForm) {
            console.error('Formulário do app não encontrado para submissão');
            return false;
        }

        console.log('=== INICIANDO SUBMISSÃO DO FORMULÁRIO DO APP ===');
        console.log('Formulário do app:', appForm);

        try {
            // Procura pelo botão de submit
            const submitButton = appForm.querySelector('button[type="submit"], [data-testid="btn-form-submit"]');
            console.log('Botão submit encontrado:', submitButton);

            if (submitButton) {
                console.log('Botão habilitado:', !submitButton.disabled);
                console.log('Aria-disabled:', submitButton.getAttribute('aria-disabled'));

                // Verifica se o botão está habilitado
                if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') {
                    console.log('Botão está desabilitado, tentando habilitar...');
                    submitButton.disabled = false;
                    submitButton.setAttribute('aria-disabled', 'false');
                }

                console.log('Clicando no botão submit...');
                submitButton.click();

                // Também tenta submeter o formulário diretamente
                setTimeout(() => {
                    console.log('Tentando submit direto do formulário...');
                    if (appForm.requestSubmit) {
                        appForm.requestSubmit();
                    } else {
                        appForm.submit();
                    }
                }, 200);

                console.log('=== SUBMISSÃO INICIADA ===');
                return true;
            } else {
                console.log('Botão submit não encontrado');
                // Lista todos os botões disponíveis
                const allButtons = appForm.querySelectorAll('button');
                console.log('Botões disponíveis:', allButtons);
                allButtons.forEach((btn, index) => {
                    console.log(`Botão ${index}:`, btn.type, btn.textContent, btn.getAttribute('data-testid'));
                });

                // Tenta submeter o formulário diretamente
                console.log('Tentando submit direto do formulário...');
                if (appForm.requestSubmit) {
                    appForm.requestSubmit();
                } else {
                    appForm.submit();
                }
                return true;
            }
        } catch (error) {
            console.error('Erro ao submeter formulário do app:', error);
            return false;
        }
    }

    // Valida os dados do formulário
    validateForm(data) {
        const errors = [];

        if (!data.responsibleName) {
            errors.push('Nome do responsável é obrigatório');
        }

        if (!data.email) {
            errors.push('E-mail é obrigatório');
        } else if (!this.isValidEmail(data.email)) {
            errors.push('E-mail inválido');
        }

        // Verifica se o campo child_name é obrigatório
        const childNameField = this.form.querySelector('#child_name');
        if (childNameField && childNameField.hasAttribute('required') && !data.childName) {
            errors.push('Nome da criança é obrigatório');
        }

        return errors;
    }

    // Valida formato do e-mail
    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Exibe mensagem para o usuário
    showMessage(message, type = 'success') {
        if (!this.messageContainer) return;

        this.messageContainer.innerHTML = `
      <div class="newsletter-message--${type}">
        ${message}
      </div>
    `;

        // Remove a mensagem após 5 segundos
        setTimeout(() => {
            this.messageContainer.innerHTML = '';
        }, 5000);
    }

    // Define estado de loading do botão
    setLoadingState(isLoading) {
        if (isLoading) {
            this.submitButton.disabled = true;
            this.submitButton.textContent = 'Enviando...';
            this.submitButton.classList.add('loading');
        } else {
            this.submitButton.disabled = false;
            this.submitButton.textContent = this.originalButtonText;
            this.submitButton.classList.remove('loading');
        }
    }

    // Usa o controlador global (como no código de referência)
    async useAppController(formData) {
        console.log('=== TENTANDO USAR CONTROLADOR GLOBAL ===');

        // Tenta usar nosso controlador personalizado primeiro
        if (window.NewsletterAppController && typeof window.NewsletterAppController.completeNewsletterFormAndSubmit === 'function') {
            console.log('NewsletterAppController encontrado, usando método personalizado...');

            try {
                const success = await window.NewsletterAppController.completeNewsletterFormAndSubmit(formData);
                return success;
            } catch (error) {
                console.error('Erro no NewsletterAppController:', error);
            }
        }

        // Fallback para o controlador original se existir
        if (window.AppNewsletterController && typeof window.AppNewsletterController.completeShopifyFormsAndSubmit === 'function') {
            console.log('AppNewsletterController encontrado, usando método global...');

            // Preenche os dados no controlador se necessário
            if (window.AppNewsletterController.setName && formData.responsibleName) {
                window.AppNewsletterController.setName(formData.responsibleName);
            }
            if (window.AppNewsletterController.setEmail && formData.email) {
                window.AppNewsletterController.setEmail(formData.email);
            }

            try {
                // Chama o método do controlador
                await window.AppNewsletterController.completeShopifyFormsAndSubmit();
                return true;
            } catch (error) {
                console.error('Erro no AppNewsletterController:', error);
            }
        }

        console.log('Nenhum controlador global encontrado, usando método direto...');
        return false;
    }

    // Submete o formulário
    async handleSubmit(event) {
        event.preventDefault();

        // Coleta e valida dados
        const formData = this.collectFormData();
        const errors = this.validateForm(formData);

        if (errors.length > 0) {
            this.showMessage(errors.join('<br>'), 'error');
            return;
        }

        // Inicia loading
        this.setLoadingState(true);

        try {
            // Debug: mostra os dados coletados
            console.log('=== INICIANDO PROCESSO DE SUBMISSÃO ===');
            console.log('Dados coletados:', formData);

            // Tenta usar o controlador global primeiro
            const controllerSuccess = await this.useAppController(formData);
            if (controllerSuccess) {
                console.log('Submissão via controlador global bem-sucedida');
                this.showMessage('Cadastro realizado com sucesso! \n Obrigado por se inscrever.', 'success');
                this.form.reset();
                return;
            }

            // Fallback: método direto
            console.log('Usando método direto...');

            // Aguarda o formulário do app estar disponível
            console.log('Procurando formulário do app...');
            const appForm = await this.waitForAppForm();
            if (!appForm) {
                console.error('Formulário do app não encontrado após aguardar');
                this.showMessage('Erro: Formulário do app não encontrado. Verifique se o app está carregado na página.', 'error');
                return;
            }

            console.log('Formulário do app encontrado, iniciando preenchimento...');

            // Preenche os campos do formulário do app
            const fillSuccess = this.fillAppForm(formData);
            if (!fillSuccess) {
                this.showMessage('Erro ao preencher dados no formulário do app.', 'error');
                return;
            }

            // Aguarda um delay maior para garantir que os campos foram preenchidos e validados
            console.log('Aguardando preenchimento dos campos...');
            await new Promise(resolve => setTimeout(resolve, 1000));

            // Submete o formulário do app
            console.log('Iniciando submissão do formulário do app...');
            const submitSuccess = this.submitAppForm();
            if (submitSuccess) {
                // Aguarda um pouco mais para o app processar
                console.log('Aguardando processamento do app...');
                await new Promise(resolve => setTimeout(resolve, 2000));

                this.showMessage('Cadastro realizado com sucesso! Obrigado por se inscrever.', 'success');
                this.form.reset();
            } else {
                this.showMessage('Erro ao submeter formulário do app.', 'error');
            }

        } catch (error) {
            console.error('Erro ao processar formulário:', error);
            this.showMessage('Erro ao realizar cadastro. Tente novamente.', 'error');
        } finally {
            this.setLoadingState(false);
        }
    }

}

// Controlador global para integração com o app (baseado no código de referência)
(function () {
    'use strict';

    // Util: dispara evento input (Shopify/App geralmente escuta isso)
    function dispatchInput(el) {
        el.dispatchEvent(new Event('input', { bubbles: true }));
    }

    // Util: obtém o form dentro do shadowRoot do #app-embed ou outros locais
    function getNewsletterForm() {
        // Tenta shadowRoot primeiro
        const host = document.getElementById('app-embed');
        if (host && host.shadowRoot) {
            const form = host.shadowRoot.querySelector('form');
            if (form) return form;
        }

        // Fallback para formulário normal
        return document.querySelector('form[data-testid="form"]') ||
            document.querySelector('form[id*="newsletter"], form[class*="newsletter"]');
    }

    // Função principal: completa o formulário e envia
    async function completeNewsletterFormAndSubmit(formData) {
        console.log('=== CONTROLADOR GLOBAL: INICIANDO SUBMISSÃO ===');
        console.log('Dados recebidos:', formData);

        const newsletterForm = getNewsletterForm();
        if (!newsletterForm) {
            console.warn('Formulário do app não encontrado via controlador global');
            return false;
        }

        console.log('Formulário do app encontrado:', newsletterForm);

        // Função para definir valor no app
        function setAppValue(appId, value) {
            const el = newsletterForm.querySelector(`#${CSS.escape(appId)}`);
            if (!el) {
                console.log(`Campo ${appId} não encontrado no app`);
                return;
            }
            console.log(`Preenchendo ${appId} com:`, value);
            el.value = value || '';
            dispatchInput(el);
            el.dispatchEvent(new Event('change', { bubbles: true }));
            el.dispatchEvent(new Event('blur', { bubbles: true }));
        }

        // Mapeamento dos campos do nosso formulário para o app
        if (formData.responsibleName) {
            setAppValue('first_name', formData.responsibleName);
        }

        if (formData.email) {
            setAppValue('email', formData.email);
        }

        if (formData.childName) {
            setAppValue('custom#nome-crianca', formData.childName);
        }

        // Seleciona opção de interesse
        if (formData.interest) {
            console.log('Selecionando interesse:', formData.interest);
            let targetRadioId = null;

            if (formData.interest.toLowerCase().includes('menino') && !formData.interest.toLowerCase().includes('menina')) {
                targetRadioId = 'custom#tenho_interesse_em_calados_para-Meninos';
            } else if (formData.interest.toLowerCase().includes('menina') && !formData.interest.toLowerCase().includes('menino')) {
                targetRadioId = 'custom#tenho_interesse_em_calados_para-Meninas';
            } else if (formData.interest.toLowerCase().includes('ambos') ||
                (formData.interest.toLowerCase().includes('menino') && formData.interest.toLowerCase().includes('menina'))) {
                targetRadioId = 'custom#tenho_interesse_em_calados_para-Meninos e Meninas';
            }

            if (targetRadioId) {
                const radioEl = newsletterForm.querySelector(`#${CSS.escape(targetRadioId)}`);
                if (radioEl) {
                    console.log('Selecionando radio:', targetRadioId);
                    radioEl.checked = true;
                    radioEl.dispatchEvent(new Event('change', { bubbles: true }));
                    radioEl.dispatchEvent(new Event('click', { bubbles: true }));
                } else {
                    console.log('Radio button não encontrado:', targetRadioId);
                }
            }
        }

        // Aguarda um pouco para os campos serem processados
        await new Promise(resolve => setTimeout(resolve, 500));

        // Clica no botão de submit
        const button = newsletterForm.querySelector('[data-testid="btn-form-submit"]') ||
            newsletterForm.querySelector('button[type="submit"]') ||
            newsletterForm.querySelector('button');

        if (button) {
            console.log('Clicando no botão submit:', button);
            button.click();
            return true;
        } else {
            console.warn('Botão do formulário não encontrado.');
            return false;
        }
    }

    // Expõe o controlador global
    window.NewsletterAppController = {
        completeNewsletterFormAndSubmit,
        getNewsletterForm
    };

    console.log('NewsletterAppController inicializado');
})();

// Inicialização automática
document.addEventListener('DOMContentLoaded', function () {
    const newsletterForms = document.querySelectorAll('[data-newsletter-form]');

    newsletterForms.forEach(form => {
        new NewsletterForm(form);
    });
});

// Exporta a classe para uso externo se necessário
if (typeof module !== 'undefined' && module.exports) {
    module.exports = NewsletterForm;
}